import * as React from "react"
import { useEffect } from "react"
import { array, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { Box } from "@mui/material"

import {COMMON_FILTER_KEYS, DIGITAL_SHELF_ROUTES, GROUPED_BY, MONITORING_ROUTES} from "@constants"
import { CommonFilters} from "@components"
import { useAppDefaultFilters } from "@hooks"
import {brand, disabledCommonFiltersSubmit, isLoadingCommonFilters, isSystemBusy, sku, skuGroup, splitKpi} from "@signals"


export default function DigitalShelfOverviewFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(DIGITAL_SHELF_ROUTES.OVERVIEW_ID, DIGITAL_SHELF_ROUTES.ACCESS_KEY)

	const { isValid, errors } = useValidatorSeeker({
		splitKpi: splitKpi.value,
		brand: brand?.value,
		sku: sku?.value,
		skuGroup: skuGroup?.value
	}, object({
		splitKpi: array().min(1, 'At least one value be provided'),
		...splitKpi.value.includes(GROUPED_BY.BRAND) && !sku?.value?.length && !skuGroup?.value && {
			brand: array()
				.min(1, "At least one brand is required")
				.max(10, "Maximun 10 brands are allowed")
		}
	}))

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	useEffect(() => {
		if (!isLoadingDefaultFilters)
			isLoadingCommonFilters.value = true
	},[isLoadingDefaultFilters])

	useEffect(() => {
		disabledCommonFiltersSubmit.value = !isValid
	}, [isValid])

	return <Box data-tour="ds-general-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			sku: true, skuGroup: true,
			splitKpi: true, brand: true,
			favFilters: true, favFiltersOnlyLine: true
		}}
		compProps={{
			country: { grid: { md: 4 } },
			site: { grid: { md: 4 } },
			brand: { grid: { md: 4 }, error: errors?.brand },
			sku: { grid: { md: 4 }, error: errors?.sku },
			skuGroup: { grid: { md: 4 }, error: errors?.skuGroup },
			favFilters: {
				grid: { md: 4 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SPLIT_KPI, COMMON_FILTER_KEYS.SELLERS
				],
				dashboardKey: DIGITAL_SHELF_ROUTES.OVERVIEW_ID
			},
			splitKpi: {
				grid: { md: 4 },
				excludeOptions: [GROUPED_BY.SKU, GROUPED_BY.SELLER, GROUPED_BY.COMPANY], error: errors?.splitKpi },
				value: splitKpi.value.some(v => v === GROUPED_BY.SKU || v === GROUPED_BY.SELLER) ? splitKpi.value = [] : splitKpi.value,
		}}

		isLoadingDefaultFilters={isLoadingDefaultFilters}
		defaultValues={userFilters}
		onSubmit={() => {
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		}}
	/>
	</Box>
}